import React from 'react';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import InfinityMenu from 'react-infinity-menu';
import './infinity-menu.css';

import Link from '../../components/Link';
import menuData from '../../data/navigation';

const MenuButton = styled.div`
    height: 80px;
    padding: 20px;
    color: ${({ isOpen }) => (isOpen ? '#20bbef' : '#003056')};
    display: block;
    font-size: 2rem;
    background-color: ${({ isOpen }) => (isOpen ? '#d9f4fc' : 'initial')};
    &:active,
    &:focus {
        background-color: transparent !important;
        outline: none;
    }
`;

const makeTree = (locale) =>
    menuData[locale].map((item, idx) => ({
        name: item.title,
        id: `${idx}`,
        isOpen: false,
        children: item.items.map((childItem, childIdx) => ({
            name: childItem.title,
            id: `${idx}.${childIdx}`,
            isOpen: false,
            link: childItem.link,
            customComponent: Item,
        })),
    }));

const Item = ({ onClick, name, data }) => {
    return (
        <li
            key={data.id}
            onClick={onClick}
            className="infinity-menu-leaf-container"
        >
            <label>
                <Link to={data.link}>{name}</Link>
            </label>
        </li>
    );
};

class Navigation extends React.Component {
    state = {
        locale: this.props.intl.locale,
        isMenuOpen: false,
        tree: makeTree(this.props.intl.locale),
    };

    static getDerivedStateFromProps(props, state) {
        if (props.intl.locale !== state.locale) {
            return {
                locale: props.intl.locale,
                tree: makeTree(props.intl.locale),
            };
        }
        return null;
    }

    render() {
        const { className } = this.props;
        const { isMenuOpen, tree } = this.state;

        return (
            <div className={className}>
                <MenuButton
                    isOpen={isMenuOpen}
                    onClick={() => this.setState({ isMenuOpen: !isMenuOpen })}
                >
                    <i className="fas fa-bars" />
                </MenuButton>
                {isMenuOpen && (
                    <InfinityMenu
                        disableDefaultHeaderContent
                        tree={tree}
                        onNodeMouseClick={this.onNodeMouseClick}
                        onLeafMouseClick={this.onLeafMouseClick}
                    />
                )}
            </div>
        );
    }

    onNodeMouseClick = (event, tree, node, level, keyPath) => {
        this.setState({
            tree: tree,
        });
    };

    onLeafMouseClick = (event, leaf) => {
        this.setState({ isMenuOpen: false });
    };
}

export default injectIntl(Navigation);



// WEBPACK FOOTER //
// ./src/layouts/components/MobileNavigation.js